<template>
  <section class="publish-form">
    <h2>¿Quieres cotizar?</h2>
    <p>Completa tus datos y nos contactaremos contigo.</p>

    <form ref="form" :action="actionUrl" method="POST" novalidate @submit.prevent="submit">
      <input type="hidden" name="_token" :value="csrf" />

      <div class="form-group">
        <label for="enterprise">Nombre de la empresa</label>
        <input id="enterprise" v-model.trim="$v.form.enterprise.$model" name="enterprise" type="text" class="form-control" :class="{ 'is-invalid': fieldInvalid('enterprise') }" />
        <small v-if="fieldInvalid('enterprise')" class="invalid-feedback d-block">{{ validationMessage('enterprise') }}</small>
      </div>
      <div class="form-group">
        <label for="first-name">Nombre</label>
        <input id="first-name" v-model.trim="$v.form.first_name.$model" name="first_name" type="text" class="form-control" :class="{ 'is-invalid': fieldInvalid('first_name') }" />
        <small v-if="fieldInvalid('first_name')" class="invalid-feedback d-block">{{ validationMessage('first_name') }}</small>
      </div>
      <div class="form-group">
        <label for="last-name">Apellidos</label>
        <input id="last-name" v-model.trim="$v.form.last_name.$model" name="last_name" type="text" class="form-control" :class="{ 'is-invalid': fieldInvalid('last_name') }" />
        <small v-if="fieldInvalid('last_name')" class="invalid-feedback d-block">{{ validationMessage('last_name') }}</small>
      </div>
      <div class="form-group">
        <label for="position">Cargo</label>
        <input id="position" v-model.trim="$v.form.position.$model" name="position" type="text" class="form-control" :class="{ 'is-invalid': fieldInvalid('position') }" />
        <small v-if="fieldInvalid('position')" class="invalid-feedback d-block">{{ validationMessage('position') }}</small>
      </div>
      <div class="form-group">
        <label for="phone">Teléfono</label>
        <input id="phone" v-model.trim="$v.form.phone.$model" name="phone" type="tel" inputmode="numeric" maxlength="9" class="form-control" :class="{ 'is-invalid': fieldInvalid('phone') }" @input="normalizePhone" />
        <small v-if="fieldInvalid('phone')" class="invalid-feedback d-block">{{ validationMessage('phone') }}</small>
      </div>
      <div class="form-group">
        <label for="email">Email</label>
        <input id="email" v-model.trim="$v.form.email.$model" name="email" type="email" class="form-control" :class="{ 'is-invalid': fieldInvalid('email') }" />
        <small v-if="fieldInvalid('email')" class="invalid-feedback d-block">{{ validationMessage('email') }}</small>
      </div>

      <privacy-consent id="publish-with-us-privacy" v-model="$v.form.privacy.$model" :invalid="$v.form.privacy.$dirty && !$v.form.privacy.accepted" />

      <button class="btn publish-form__submit" :disabled="submitting" type="submit">{{ submitting ? 'ENVIANDO...' : 'ENVIAR' }}</button>
    </form>
  </section>
</template>

<script>
import { email, maxLength, minLength, required } from 'vuelidate/lib/validators';
import PrivacyConsent from '../../components/PrivacyConsent.vue';

const accepted = (value) => value === true;

export default {
  components: { PrivacyConsent },
  props: {
    actionUrl: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    submitting: false,
    form: {
      enterprise: '',
      first_name: '',
      last_name: '',
      position: '',
      phone: '',
      email: '',
      privacy: false,
    },
  }),
  methods: {
    fieldInvalid(field) {
      return this.$v.form[field].$dirty && this.$v.form[field].$invalid;
    },
    validationMessage(field) {
      const validation = this.$v.form[field];

      if (!validation.required) {
        return 'Campo obligatorio';
      }

      if (field === 'email' && !validation.email) {
        return 'Ingresa un email válido';
      }

      if (!validation.maxLength || !validation.minLength) {
        return field === 'phone' ? 'Ingresa un teléfono de 9 dígitos' : 'El valor ingresado es demasiado largo';
      }

      return 'El valor ingresado es demasiado largo';
    },
    normalizePhone() {
      this.form.phone = this.form.phone.replace(/\D/g, '').slice(0, 9);
    },
    submit() {
      this.$v.form.$touch();

      if (!this.$v.form.$invalid) {
        this.submitting = true;
        this.$refs.form.submit();
      }
    },
  },
  validations: {
    form: {
      enterprise: { required, maxLength: maxLength(150) },
      first_name: { required, maxLength: maxLength(100) },
      last_name: { required, maxLength: maxLength(100) },
      position: { required, maxLength: maxLength(100) },
      phone: { required, minLength: minLength(9), maxLength: maxLength(9) },
      email: { required, email, maxLength: maxLength(150) },
      privacy: { accepted },
    },
  },
};
</script>
